import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd } from '@angular/router';
import { Memo } from '../video-detail-v2/video-detail-memo';
import { videoDetailThemeKey, videoDetailThemeVars } from '../video-detail-v2/video-detail-theme';
import { libraryBackUrl, libraryCountLabel, libraryCover, libraryInitial } from './library-card';
declare let ga: Function;

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {
  openRightSideNav: boolean = false;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  playListAry = [];
  formType = "Create"
  channelName: any;
  editData: any = {}
  performerInfoSubscr: Subscription;
  routerevents: any;
  assets_url = environment.assets_url;
  /** Playlists have been read (until then no empty message). */
  loaded = false;
  settingsData: any = {};
  settingsSubscription: Subscription;
  readonly cover = libraryCover;
  readonly countLabel = libraryCountLabel;
  readonly initial = libraryInitial;
  private readonly themeMemo = new Memo<Record<string, string>>();

  /** The network's colours, as on the new video pages. */
  get themeVars(): Record<string, string> {
    return this.themeMemo.get(videoDetailThemeKey(this.settingsData), () => videoDetailThemeVars(this.settingsData));
  }

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.channelName = this.router.url.split("/")[1];
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData || {};
    this.settingsSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response || {};
    });
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    })
    if (Object.keys(perfomerInfoData).length > 0)
      this.getPerformerInfo(perfomerInfoData);

  }
  org_info: any = {};
  performer_details: any = {};
  performer_id: any;
  organization_id: any;
  getPerformerInfo(response) {
    if (response.data.statusCode === '200') {
      try { ga('set', 'page', this.router.url); ga('send', 'pageview'); } catch (e) { }
      if (response.data.Data[0].performer_id) {
        this.performer_id = response.data.Data[0].performer_id;
        this.organization_id = response.data.Data[0].organization_id || null;
        this.getUserPlaylist();
      }
      if (response.data.Data[0].performer_details) {
        this.performer_details = response.data.Data[0].performer_details;
      }
    }
  }

  rightSideNav(data?, type?) {
    this.editData = data;
    this.openRightSideNav = true;
    this.formType = type;
  }

  getUserPlaylist() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user_id": this.userInfo.id,
        "performer_id": this.performer_id,
        "organization_id": this.organization_id || null
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_PLAYLIST, data).then(response => {
      this.ngxLoader.stop();
      this.loaded = true;
      if (response.data.statusCode === '200') {
        this.playListAry = [];
        if (response['data']['Data'] && response['data']['Data'].length > 0) {
          this.playListAry = response.data['Data'];
          this.playListAry.forEach(e => {
            if (e.stream_ids && e.stream_ids.length > 0) {
              e.songsCount = e.stream_ids.length;
            }
          });
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
      this.loaded = true;
    });
  }

  deletePlaylist(playlist) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '370px',
      panelClass: 'app-confirmation-dialog',
      data: {
        title: "Are you sure you want to delete playlist?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        let data = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": environment.AWS_Cognito.X_Api_Key,
            "Authorization": `Bearer ${this.userInfo.access_token}`
          },
          response: true,
          body: {
            "id": playlist.id
          }
        }
        this.ngxLoader.start();
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.DELETE_USER_PLAYLIST, data).then(response => {
          this.ngxLoader.stop();
          if (response.data.statusCode === '200') {
            this.toastr.success('Playlist deleted successfully');
            this.getUserPlaylist();
          }
        }).catch(error => {
          this.ngxLoader.stop();
        });
      }
    });
  }
  goBack() {
    this.router.navigateByUrl(libraryBackUrl(this.channelName));
  }

  goToPlaylist(playlist_id) {
    this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + `/playlist/${playlist_id}`]);
  }

  getResultFromAddList(e) {
    if (e == 'close') {
      this.openRightSideNav = false
    }
    if (e == 'success') {             // after successfully edited
      this.getUserPlaylist()
      this.openRightSideNav = false
    }
  }

  ngOnDestroy() {
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    } if (this.performerInfoSubscr)
      this.performerInfoSubscr.unsubscribe();
    if (this.settingsSubscription)
      this.settingsSubscription.unsubscribe();
  }
}
